export enum UploadStatus {
  Waiting = "File is waiting",
  Processing = "File is being processed",
  Success = "Success",
  Failed = "Upload failed",
  CanNotUploadFile = "Cannot upload this file",
}
